export const EXPERT_DATA_LOADED = 'EXPERT_DATA_LOADED';
export const EXPERT_DATA_UNLOAD = 'EXPERT_DATA_UNLOAD';
export const EXPERT_NOT_FOUND = 'EXPERT_NOT_FOUND';
export const UPDATE_EXPERT_DATA = 'UPDATE_EXPERT_DATA';
